<template>

  <RadioGroup v-model="selected_value" class="mt-2">
    <div class="grid grid-cols-3 gap-3">
      <RadioGroupOption
        as="template"
        v-for="(container_status) in container_statuses"
        :key="container_status.id"
        :value="container_status.id"
        v-slot="{ active, checked }"
      >
        <div
          :class="[
            'cursor-pointer focus:outline-none',
            active
              ? 'ring-2 ring-offset-2 ring-'+(container_status.color)+'-500'
              : '',
            checked
              ? 'bg-'+(container_status.color)+'-100 border-transparent text-'+(container_status.color)+'-800 hover:bg-'+(container_status.color)+'-100'
              : 'bg-white border-gray-200 text-gray-900 hover:bg-slate-50',
            'border rounded-md py-1 px-1 flex items-center justify-center text-sm font-medium sm:flex-1',
          ]"
        >
          <RadioGroupLabel as="span">
            {{ container_status.name }}
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";

export default {
  ame: "AEProductionBasicContainerExportPackageDetailSelector",
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption },
  props: ["modelValue"],
  data() {
    return {
      selected_value: this.modelValue,
      container_statuses: [
        {id: 0, name: 'Sin detalle', color: 'gray'},
        {id: 1, name: 'Por pallet', color: 'green'},
        {id: 2, name: 'Por caja', color: 'green'},
      ]
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>
